import React from 'react';

import Chip from '@mui/material/Chip';
import Avatar from 'material-ui/Avatar';

import theme from '../../muiTheme';
import './RequiredFieldStatus.css';

const RequiredFieldStatus = (props) => {

  return (
    <Chip
      className="required-field-status-chip"
      onClick={props.chipClicked}
      backgroundColor="#ECEFF5"
      label=" Required Fields Missing"
      labelStyle={{lineHeight: "21px"}}
      avatar={<Avatar style={{fontSize: "12px", width: "22px", height: "22px"}} backgroundColor={theme.palette.accent1Color}>{props.missingFields}</Avatar>} />
  );
}

export default RequiredFieldStatus;
